import { useCallback, useMemo } from 'react'
import { FormikHelpers } from 'formik'
import { message } from 'antd'
import { useParams } from 'react-router-dom'
import { useBackgroundNavigate } from '@shared/hooks'
import { FormOptions } from '@shared/modules/form/types'
import { WarehousesService } from '../services'
import { WarehouseFormData } from '../types'
import { useWarehouseFormInitialData } from './use-form-initial-data'

export const useWarehouseForm = ({ type = 'create', redirectUrl }: FormOptions) => {
  const { id = '' } = useParams<{ id?: string }>()
  const navigate = useBackgroundNavigate()

  const baseInitialValues = useMemo<WarehouseFormData>(
    () => ({ id, isMain: false, address: '', departmentId: '', descr: '', stateId: '', warehouseCode: '', warehouseName: '' }),
    [id],
  )

  const initialValues = useWarehouseFormInitialData({ id: id, initialValues: baseInitialValues })

  const onSubmit = useCallback(
    async (values: WarehouseFormData, helpers: FormikHelpers<WarehouseFormData>) => {
      helpers.setStatus(null)
      const result = await WarehousesService.createOrUpdate(values, type)

      if (result.status === 200) {
        if (redirectUrl) {
          navigate(redirectUrl)
        } else {
          helpers.resetForm()
        }
        message.success('Məlumatlar müvəffəqiyyətlə yeniləndi.')
      } else if (result.status === 422) {
        helpers.setErrors(result.data)
      } else {
        helpers.setStatus({ type: 'error', message: result.data })
      }
    },
    [navigate, redirectUrl, type],
  )

  return { initialValues, onSubmit }
}
